import Api from '@/services/Index';

const getAll = async (config) => {
    return Api.get('/student/sessions/course-approval',config);
}

export default {
    getAll,
}
